module.exports = __webpack_public_path__ + "static/media/linkedin.4ba369cc.svg";